import { render, staticRenderFns } from "./userMod.vue?vue&type=template&id=5867d1c8&scoped=true&"
import script from "./userMod.vue?vue&type=script&lang=js&"
export * from "./userMod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5867d1c8",
  null
  
)

export default component.exports